import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IContactActionModel } from '@apps-common/types/management/contact'

export const getContactActions = async (): Promise<IContactActionModel[]> =>
  axios.get(`/management/contact/getcontactactions`).then((res) => res.data?.data)

type QueryFnType = typeof getContactActions

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetContactActions = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: ['getContactActions'],
    queryFn: () => getContactActions()
  })
